import { render, staticRenderFns } from "./KsIconButton.vue?vue&type=template&id=86e44112&scoped=true"
import script from "./KsIconButton.vue?vue&type=script&lang=js"
export * from "./KsIconButton.vue?vue&type=script&lang=js"
import style0 from "./KsIconButton.vue?vue&type=style&index=0&id=86e44112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e44112",
  null
  
)

export default component.exports